import * as React from 'react'
import EnumCombobox, { EnumComboboxProps } from './EnumCombobox'
import { Billable } from '../../config/registration/timeConfig'

export type BillableComboboxProps = Omit<EnumComboboxProps<Billable>, 'entities' | 'multiselect' | 'labelKeyPrefix'>

export default function BillableCombobox(props: BillableComboboxProps) {
    return (
        <EnumCombobox<Billable>
            required
            entities={Object.values(Billable)}
            labelKeyPrefix={'base.billable'}
            placeholderKey={'base.billable.placeholder'}
            {...props}
        />
    )
}
